export default "__VITE_ASSET__DzpNVV_E__"